import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IEssentialsModule } from '@devinforius/i-essentials';
import { ToastModule } from 'primeng/toast';
import { ITableModule } from '@devinforius/i-table';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationDialogComponent } from './components';

@NgModule({
  declarations: [
    ConfirmationDialogComponent
  ],
  imports: [
    CommonModule,
    ConfirmDialogModule,
    IEssentialsModule
  ],
  exports : [
    IEssentialsModule,
    ITableModule,
    ToastModule,
    ConfirmDialogModule,
    CommonModule,

    // Components
    ConfirmationDialogComponent
  ]
})
export class SharedModule { }
